// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__l5D9S","title":"style_title__KY1fA","subTitle":"style_subTitle__pH7d3"};